export default __webpack_public_path__ + "static/media/PCbg01.ea1753f5.png";